import { useEffect, useRef, useState } from "react"
import { widgetLegends } from "../widgetLegends";
import { sleep } from "../utils/misc";
import { lerp } from "../utils/math";

export function getClosestWidgetName(el) {
    if (el.dataset && el.dataset.widgetId) return el.dataset.widgetId;
    if (el.parentNode) return getClosestWidgetName(el.parentNode);
}

const HelpBoxFrame = ({ref, className, children}) => <div ref={ref} data-widget-id="helpBox" style={{overflow: "hidden"}} className={`gruf-modul ${className}`}>{children}</div>

export const HelpBox = ({className, style}) => {
    const [widgetID, setWidgetID] = useState();
    useEffect(() => {
        const updateWidgetID = e => setWidgetID(getClosestWidgetName(e.target));
        document.addEventListener("mousemove", updateWidgetID);
        document.addEventListener("focusin", updateWidgetID);
        return () => {
            document.removeEventListener("mousemove", updateWidgetID);
            document.removeEventListener("focusin", updateWidgetID);
        }
    }, []);

    const frameRef = useRef();
     
    function smoothScrollTo(element, endPos, speed, signal) { // speed in px per second
        const startPos = element.scrollTop;
        const duration = Math.abs(endPos - startPos) / speed * 1000; // in milliseconds
        let startTime;
        let resolve, reject;
        const promise = new Promise((res, rej) => {resolve=res; reject=rej});
        function scrollStep(timestamp) {
            if (signal.aborted) return reject();
            startTime ??= timestamp;
            const elapsed = timestamp - startTime;
            if (elapsed >= duration) {
                element.scrollTop = endPos;
                return resolve();
            }
            element.scrollTop = lerp(startPos, endPos, elapsed/duration);
            requestAnimationFrame(scrollStep);
        }
        requestAnimationFrame(scrollStep);
        return promise;
    }
    useEffect(() => {
        if (frameRef.current == null) return;
        const height = frameRef.current.clientHeight;
        const scrollHeight = frameRef.current.scrollHeight;
        if (scrollHeight <= height) return;
        const controller = new AbortController();
        async function loop() {
            const staticTime = 2000;
            const speed = 10;
            try {
                // wait on top
                await sleep(staticTime, controller.signal);
                // scroll to bottom
                await smoothScrollTo(frameRef.current, scrollHeight - height, speed, controller.signal);
                // wait on bottom
                await sleep(staticTime, controller.signal);
                // scroll to top
                await smoothScrollTo(frameRef.current, 0, speed, controller.signal);
                loop();
            } catch {
                return;
            }
        }
        loop();
        return () => controller.abort();
    }, [widgetID])

    if (!widgetID) return <HelpBoxFrame className={className}/>
    const widgetTextData = widgetLegends[widgetID];
    if (!widgetTextData) return <HelpBoxFrame className={className}/>

    return <HelpBoxFrame ref={frameRef} className={className}>
        {widgetTextData.title && <span style={{fontWeight: "bold"}}>{widgetTextData.title.ca}.</span>}
        {widgetTextData.description && <span>{" " + widgetTextData.description.ca}</span>}
    </HelpBoxFrame>
}